import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseURL = 'https://portal.palmettoeoc.com/prod/public/api/cognito/account';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  endpoints: (builder) => ({
    verifyToken: builder.query<IUserPortal, string>({
      query: (token) => ({
        url: '',
        headers: { Authorization: token },
      }),
    }),
  }),
});

export const { useLazyVerifyTokenQuery } = authApi;
